export default __webpack_public_path__ + "static/mc-edit-person-a2d3c3c6b3d0c848662f2364190b7187.mp4";